/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2022
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/

export const SWAGGER2_ENDPOINT_METHODS = [
  'get',
  'put',
  'post',
  'delete',
  'options',
  'head',
  'patch'
];

export const OAS3_ENDPOINT_METHODS = SWAGGER2_ENDPOINT_METHODS.concat([
  'trace'
]);

export const ENDPOINT_HEADERS = [
  { key: 'title', header: 'Operation' },
  { key: 'method', header: 'Method' },
  { key: 'path', header: 'Resource' }
];

export const GETTER = 'getter';
export const SETTER = 'setter';
export const REQUIRED = 'Required';
export const OPTIONAL = 'Optional';
export const RESPONSE_PROPERTY = 'responseProperty';
export const REQUEST_PARAMETER = 'requestParameter';
export const DATA_TYPE = 'Data Type';
export const BODY = 'body.';
